// extracted by mini-css-extract-plugin
module.exports = {"Icon":"index-module__Icon___39C7a"};